module.exports = __webpack_public_path__ + "static/media/H5jjgq.b6f661db.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/activity/FloatCouponSpecial/images/H5jjgq.gif
// module id = 1838
// module chunks = 6